import React, { Fragment, useEffect, useState } from "react";
import { Dialog, DialogContent, Grid, Typography } from "@material-ui/core";
import codeMask from "Components/Input/components/codeMask";
import Input from "Components/Input/Input";
import MuiButton from "Components/MuiButton/MuiButton";
import { useSetState } from "Helpers/Hooks";
import UserProfileService from "Services/http/endpoints/userProfile/UserProfileService";
import StatusHandler from "Helpers/StatusHandler";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import Translator from "Languages/Utility/Translator";
import { convertToEnglishNumber } from "../../../../Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';

function VerifyModal({ open, type, handleDialog, account, resendCode }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(60);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useSetState({
    authNumber: {
      value: "",
      validation: {
        required: true,
      },
    },
  });

  const setValue = (name, value) => {
    setState({ [name]: { value: value } });
  };

  const onEnter = async () => {
    setSeconds(60);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const { authNumber } = state;
    try {
      setLoading(true);
      if (type === 2) {
        const enPhone = convertToEnglishNumber(account);
        const phoneWithCode = enPhone.replace("0", "+98");
        const dataPhone = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Type: type,
          Account: phoneWithCode,
          Token: authNumber.value,
        };
        const response = await UserProfileService.putChangeAcount(dataPhone);
        let err = StatusHandler(response);
        if (!err.isFail) {
          handleDialog(true);
          showNotify({
            text: t('mission_accomplished'),
            customClass: "success",
          });
        } else {
          handleDialog(false);
        }
      }
      if( type === 1){
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Type: type,
          Account: account,
          Token: authNumber.value,
        };
        const response = await UserProfileService.putChangeAcount(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          handleDialog(true);
          showNotify({
            text: t('mission_accomplished'),
            customClass: "success",
          });
        } else {
          handleDialog(false);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      handleDialog(false);
    }
  };

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  useEffect(() => {
    if (open) {
      setSeconds(59);
    } else {
    }
  }, [open]);

  const callResendCode = () => {
    setSeconds(59);
    resendCode();
  };

  return (
    <>
      <Dialog
        dir={direction}
        open={open}
        onEnter={onEnter}
        onClose={handleDialog}
        fullWidth
        maxWidth="sm"
      >
        <form>
          <DialogContent>
            <Grid container>
              <Grid item xs={12} className="px-4 py-3">
                <Input
                  className="ltr"
                  setValue={setValue.bind(this)}
                  name="authNumber"
                  validation={state.authNumber.validation}
                  label={<Translator id={"Shomare"} />}
                  type="text"
                  fullWidth
                  inputComponent={codeMask}
                />
              </Grid>
            </Grid>
            <div className="mt-3 ">
              {seconds === 0 ? (
                <Fragment>
                  <Typography
                    component="div"
                    variant="body1"
                    className="text-center"
                  >
                    <span>
                      {<Translator id="did_you_receive_text_message" />}
                    </span>
                  </Typography>

                  <div className="d-flex justify-content-center m-3">
                    <MuiButton
                      className="w-100"
                      onClick={callResendCode}
                      variant="contained"
                      title={<Translator id={"resend"} />}
                    />
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <Typography
                    component="div"
                    variant="body1"
                    className="text-center"
                  >
                    <span>
                      {
                        <Translator id="please_wait_to_receive_the_verification_code" />
                      }{" "}
                    </span>
                    <span className="mx-2">
                      {" "}
                      {seconds < 10 ? `0${seconds}` : seconds}{" "}
                    </span>
                  </Typography>
                  <div className="d-flex justify-content-center m-3">
                    <MuiButton
                      loading={loading}
                      className="w-100"
                      onClick={onFinish}
                      variant="contained"
                      color="primary"
                      title={<Translator id={"send"} />}
                    />
                  </div>
                </Fragment>
              )}
            </div>
          </DialogContent>
        </form>
      </Dialog>
    </>
  );
}

export default VerifyModal;
